import React from 'react'
import { Container, Row, Col, Image, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router";
import OffShoreTeamCarousel from './OffShoreTeamCarousel';
import TechBlock from '../TechBlock';
import OffShoreTeamFaq from './OffShoreTeamFaq';
import ServiceSlider from './ServiceSlider';

import gradient from "../../Assets/banner-blue-pill.png";

export default function OffShoreTeamServices() {
    return (
        <>
            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">
                    <Breadcrumb className="custom-breadcrumb">
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item href="/service">
                            Services
                        </Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item active>Offshore Team Setup Services</Breadcrumb.Item>
                    </Breadcrumb>
                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">Offshore Team Setup</span> Services</h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Dedicated teams that work with your processes and continue to deliver without constant handholding.</h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">What Is an <span className="text-gradient-1">Offshore Team Setup</span></h2>
                        </Col>
                        <h5 className='heading-style-h5 mb-5'>Offshore team setup is about creating a team that works with your delivery model, not outside it. This setup is often referred to as a dedicated offshore development team, where the focus is on long-term alignment rather than short-term support.</h5>
                        <h5 className='heading-style-h5 mb-5'>Instead of just adding capacity, it gives you a team that stays aligned with your workflows, communication, and priorities.</h5>
                        <h5 className='heading-style-h5'>For some businesses, this means faster delivery. For others, it means fewer handovers, better continuity and more predictable output.</h5>
                        <h5 className='heading-style-h5'>The focus is on making offshore teams feel like part of your own setup, not a separate layer you have to manage.</h5>
                    </Row>
                </Container>
            </section>
            <Container className="padding-section-large">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Offer in <span className="text-gradient-1">Offshore Team Setup</span></h2>
                        <h5 className='heading-style-h5 pb-5'>Core offshore team services built around delivery continuity, workflow alignment and long-term support.</h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard bg-gradient-1 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>

                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Dedicated Development Teams</h4>
                            <p className="desc">We set up dedicated teams based on the skills, roles and delivery support your project actually needs. The goal is to give you dependable capacity without needing to rebuild your internal team structure.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Team setup based on project scope</span>
                                <span>Access to the right technical roles</span>
                                <span>Support for changing delivery needs</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Seamless Team Integration</h4>
                            <p className="desc">The offshore team is aligned with your workflows, communication methods, and day-to-day processes. This helps the team contribute as part of your existing setup rather than operating separately.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Workflow and process alignment</span>
                                <span>Clear communication structure</span>
                                <span>Coordination with internal teams</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Long-Term Engagement Support</h4>
                            <p className="desc">Offshore teams work best when they support continuity over time. We focus on creating team structures that can contribute beyond short-term delivery and remain effective as needs evolve.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Consistent delivery support</span>
                                <span>Continuity across ongoing work</span>
                                <span>Readiness for long-term collaboration</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={10}>
                            <h2 className='heading-style-h2 pb-3'>Setting Up the Right Team Structure</h2>
                            <p>From team structure to day-to-day alignment, we’ll help you figure out what fits best.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={2} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Talk to Our Team</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <OffShoreTeamCarousel />
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className=''>
                        <Col md={10}>
                            <h2 className="heading-style-h2 pb-3">What It Means for <span className="text-gradient-1">Your Business</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Stronger delivery, better team continuity, and fewer gaps between planning and execution.</h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch stagger-wrapper">
                        <div className="stagger-grid">
                            {/* Card 1 */}
                            <div className="card-box primary-border light-bg logo-bg">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Expand delivery capacity without slowing down</h5>
                                <p>Add the support you need without long hiring cycles or disrupting existing teams.</p>
                            </div>

                            {/* Card 2 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Keep work moving with consistent team involvement</h5>
                                <p>Avoid handovers and context loss with a team that stays aligned over time.</p>
                            </div>

                            {/* Card 3 */}
                            <div className="card-box card-2">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Work as one team, not separate units</h5>
                                <p>Offshore and internal teams operate together with shared workflows and clear coordination.</p>
                            </div>

                            {/* Card 4 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Adjust quickly as priorities change</h5>
                                <p>Scale roles and responsibilities without breaking delivery flow or creating delays.</p>
                            </div>

                            {/* Card 5 */}
                            <div className="card-box card-4">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Create a more dependable way to deliver work</h5>
                                <p>Create a setup that supports ongoing work, not just short-term execution.</p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
            <TechBlock />
            <ServiceSlider />
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={9}>
                            <h2 className='heading-style-h2 pb-3'>The Right Team, Without the Hiring Overhead</h2>
                            <p>If you’re looking for dedicated support that fits your workflows and stays aligned over time, we can help you set up the right team.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={3} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Build Your Offshore Team</Link>
                        </Col>
                    </Row>
                </Container>
            </section>
            <OffShoreTeamFaq />
        </>
    )
}
